module.exports = __webpack_public_path__ + "img/activate.383ac40b.svg";